/* eslint-disable react/prop-types */
import { graphql } from "@apollo/client/react/hoc"
import { useParams } from "react-router-dom"
import { compose, withProps } from "recompose"
import gql from "graphql-tag"
import CaseListCard from "./"

const CaseListCardWithData = compose(
  withProps(() => {
    const { facilityId } = useParams()
    return {
      facilityId,
    }
  }),
  graphql(
    gql`
      query ContactTracingCaseListCard($facilityId: ID!, $archived: Boolean!) {
        facility(id: $facilityId) {
          id
          contactTracingCases(archived: $archived) {
            id
            internalId
            type
          }
        }
      }
    `,
    {
      options: ({ facilityId, listType }) => ({
        variables: {
          facilityId,
          archived: listType === "archived",
        },
      }),
      props: ({ data: { error, loading, facility }, ownProps }) => {
        if (error) throw error

        if (loading) return { loading }

        return {
          cases: facility.contactTracingCases.map((kase) => ({
            internalId: kase.internalId,
            name:
              kase.type === "patientPositive"
                ? "Patient Positive"
                : "Employee Positive",
          })),
        }
      },
    }
  )
)(CaseListCard)

export default CaseListCardWithData
